export default {
  colors: ['白', '黑', '灰银', '蓝', '红', '棕', '灰', '橙', '黄', '绿', '香槟', '紫', '粉']
}
